// extracted by mini-css-extract-plugin
export default {"svg":"DropdownTick_svg__0uHFF"};